import React, { useEffect, useState } from 'react'
import {
  CCloseButton,
  COffcanvas,
  COffcanvasBody,
  COffcanvasHeader,
  COffcanvasTitle,
} from '@coreui/react-pro'
import PlatformAnalyticsService from 'src/service/PlatformAnalyticsService'
import { useChartTheme } from '../AnalyticsV2/chartTheme'
import { ChartSkeleton, ErrorState, formatNumber } from '../AnalyticsV2/common'
import RankedBarList from '../AnalyticsV2/RankedBarList'
import { errorMessage } from './platformHelpers'

/** "Which games is this screen used in?" — opened from any top-screens list. */
const ScreenGamesOffcanvas = ({ screen, filters, reloadToken, onClose, onOpenGame }) => {
  const theme = useChartTheme()
  const [state, setState] = useState({ data: null, loading: false, error: null })
  const [retry, setRetry] = useState(0)

  useEffect(() => {
    if (!screen) return undefined
    let cancelled = false
    setState({ data: null, loading: true, error: null })
    PlatformAnalyticsService.getScreenGames(filters, screen)
      .then((res) => {
        if (cancelled) return
        setState(
          res?.success
            ? { data: res.data, loading: false, error: null }
            : { data: null, loading: false, error: errorMessage(res) },
        )
      })
      .catch(
        (err) => !cancelled && setState({ data: null, loading: false, error: errorMessage(err) }),
      )
    return () => {
      cancelled = true
    }
  }, [screen, filters, reloadToken, retry])

  const d = state.data

  return (
    <COffcanvas placement="end" visible={Boolean(screen)} onHide={onClose} className="pa-offcanvas">
      <COffcanvasHeader className="border-bottom">
        <div className="min-w-0">
          <COffcanvasTitle className="text-truncate av2-screen-name">{screen}</COffcanvasTitle>
          <div className="small text-medium-emphasis">Which games this screen is viewed in</div>
        </div>
        <CCloseButton className="text-reset ms-auto" onClick={onClose} />
      </COffcanvasHeader>
      <COffcanvasBody>
        {state.loading && <ChartSkeleton height={260} />}
        {state.error && (
          <ErrorState message={state.error} onRetry={() => setRetry((r) => r + 1)} height={240} />
        )}
        {d && (
          <>
            <div className="d-flex flex-wrap gap-2 mb-3">
              <span className="av2-chip">
                <strong>{formatNumber(d.views)}</strong> views
              </span>
              <span className="av2-chip">
                <strong>{formatNumber(d.users)}</strong> people
              </span>
              <span className="av2-chip">
                in <strong>{formatNumber(d.games)}</strong> games
              </span>
            </div>
            <div className="pa-ranked-plain">
              <RankedBarList
                rows={d.rows.map((r) => ({
                  key: r.game_id,
                  label: r.game_name,
                  sublabel: `#${r.game_id}`,
                  value: r.views,
                  share: d.views ? (r.views / d.views) * 100 : 0,
                  people: r.users,
                }))}
                color={theme.series[0]}
                valueLabel="views"
                emptyLabel="No views of this screen in this period."
                onRowClick={(row) => onOpenGame({ id: row.key, game_name: row.label })}
              />
            </div>
          </>
        )}
      </COffcanvasBody>
    </COffcanvas>
  )
}

export default ScreenGamesOffcanvas
